import React from 'react'
import Marquee from "react-fast-marquee";
import CommonTile from '../component/commonTile'

import './index.less'

export default function Page5() {
  return (
    <div>
      <CommonTile title="携手伙伴共筑未来" />
      <div className='home-enterprise'>
        <Marquee autoFill speed={40} gradient>
          <img src={require('../../../assets/image/home/enterprise.png')}/>
        </Marquee>
        <Marquee autoFill speed={60} gradient gradientWidth={100}>
          <img src={require('../../../assets/image/home/enterprise1.png')}/>
        </Marquee>
        <Marquee autoFill speed={40} gradient>
          <img src={require('../../../assets/image/home/enterprise2.png')}/>
        </Marquee>
      </div>
    </div>
  )
}
